import React from "react";
import { IoInformationCircleOutline } from "react-icons/io5";

const VersionDisplay = ({ isCompany }) => {
  const version = process.env.REACT_APP_VERSION || "1.0.0";

  return (
    <div
      className={`absolute top-2 flex items-center gap-2  px-3 py-1.5 rounded-full ${
        isCompany ? "right-20" : "right-2"
      } `}
    >
      {/* <IoInformationCircleOutline className="text-gray-500" /> */}
      <span className="text-xs font-medium text-gray-600">v{version}</span>
    </div>
  );
};

export default VersionDisplay;
